export function projectedUsage(summary, selectedCount = 0) {
  return summary ? summary.used + selectedCount : null;
}

export function isOverSubscriptionLimit(summary, selectedCount = 0) {
  return Boolean(
    summary &&
      Number.isFinite(summary.limit) &&
      summary.limit >= 0 &&
      projectedUsage(summary, selectedCount) > summary.limit
  );
}
